/**
 * Platform-wide job-title suggestions for the Contact Discovery typeahead
 * (TD-2105, Contact Enrichment Stream B).
 *
 * This is a single shared list — there is intentionally NO per-customer
 * configuration. Users may also enter free-text titles beyond these
 * suggestions; this list only seeds the typeahead.
 *
 * Entries are stored display-ready (Title Case). Matching against typed input
 * is case-insensitive (the typeahead lower-cases both sides), so casing here is
 * purely for presentation in the suggestion list and resulting chips.
 */
const discoverSuggestions = [
  'Chief Executive Officer',
  'Chief Financial Officer',
  'Chief Operating Officer',
  'Chief Technology Officer',
  'Chief Information Officer',
  'Chief Marketing Officer',
  'Chief Revenue Officer',
  'Chief Product Officer',
  'Managing Director',
  'President',
  'Vice President',
  'Senior Vice President',
  'Executive Vice President',
  'General Manager',
  'Owner',
  'Founder',
  'Co-Founder',
  'Partner',
  'Managing Partner',
  'Board Member',
  'Head of Sales',
  'Head of Marketing',
  'Head of Finance',
  'Head of Operations',
  'Head of Product',
  'Head of Engineering',
  'Head of Human Resources',
  'Director of Sales',
  'Director of Marketing',
  'Director of Finance',
  'Director of Operations',
  'Finance Director',
  'Sales Director',
  'Marketing Director',
  'Operations Director',
  'Procurement Manager',
  'Purchasing Manager',
  'Sales Manager',
  'Marketing Manager',
  'Operations Manager',
  'Product Manager',
  'Project Manager',
  'Account Manager',
  'Business Development Manager'
];

export default discoverSuggestions;
